import { render, staticRenderFns } from "./Commu.vue?vue&type=template&id=363f842d"
import script from "./Commu.vue?vue&type=script&lang=js"
export * from "./Commu.vue?vue&type=script&lang=js"
import style0 from "./Commu.vue?vue&type=style&index=0&id=363f842d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports